import EditAdminDialog from './editAdminDialog.container';

export default EditAdminDialog;
